/**
 * Parse sortBy from URL query to array
 */
export const parseSortBy = (queryValue, defaultValue = []) => {
    if (!queryValue) return defaultValue;
    return Array.isArray(queryValue) ? queryValue : [queryValue];
};

/**
 * Check if sortBy changed between two query objects
 */
export const sortByChanged = (newQuery, oldQuery) => {
    return JSON.stringify(newQuery.sortBy) !== JSON.stringify(oldQuery.sortBy);
};

/**
 * Get current direction for a field from sortBy array
 * @returns 'asc' | 'desc' | null
 */
export const getSortDirection = (sortByArray, field) => {
    const found = sortByArray.find((s) => s.startsWith(field + ':'));
    if (!found) return null;
    return found.endsWith(':asc') ? 'asc' : 'desc';
};

/**
 * Toggle sort for a field: always switches direction
 * asc → desc, desc → asc, null → asc
 * @param allowMultiple - if false, replaces entire array with single field
 * @returns new sortBy array
 */
export const toggleSort = (sortByArray, field, allowMultiple = false) => {
    const currentDir = getSortDirection(sortByArray, field);
    const filtered = sortByArray.filter((s) => !s.startsWith(field + ':'));
    const newDir = currentDir === 'asc' ? 'desc' : 'asc';
    return allowMultiple ? [...filtered, `${field}:${newDir}`] : [`${field}:${newDir}`];
};

export const isFieldSorted = (sortByArray, field) => {
    const isSorted = sortByArray.some((s) => s.startsWith(field + ':'));
    return isSorted;
};

export const useSortBy = () => {
    return {
        parseSortBy,
        sortByChanged,
        getSortDirection,
        toggleSort,
        isFieldSorted,
    };
};

export default useSortBy;
